__turbopack_context__.v({
  "tabButton": "qoeZ8G_tabButton",
  "tabList": "qoeZ8G_tabList",
});
